import { render, staticRenderFns } from "./GroupStatsTable.vue?vue&type=template&id=6493d0fc&scoped=true"
import script from "./GroupStatsTable.vue?vue&type=script&lang=js"
export * from "./GroupStatsTable.vue?vue&type=script&lang=js"
import style0 from "./GroupStatsTable.vue?vue&type=style&index=0&id=6493d0fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6493d0fc",
  null
  
)

export default component.exports